import { createContext, useState, useEffect, useContext } from "react";
import { PropTypes } from "prop-types";

export const RecommendedOutfitsProductsContext = createContext({});

// TODO This variable mimics what a response from the Recommended Outfits API product summaries would return, needs mapping
const mockRecommendedOutfitsProductsData = require("./mockRecommendedOutfitsProducts");

export const RecommendedOutfitsProductsProvider = ({ children }) => {
  const [recommendedOutfitsProducts, setRecommendedOutfitsProducts] =
    useState();

  useEffect(() => {
    setRecommendedOutfitsProducts(mockRecommendedOutfitsProductsData);
  }, []);

  return (
    <RecommendedOutfitsProductsContext.Provider
      value={{ recommendedOutfitsProducts }}
    >
      {children}
    </RecommendedOutfitsProductsContext.Provider>
  );
};

export const useRecommendedOutfitsProducts = () =>
  useContext(RecommendedOutfitsProductsContext);

RecommendedOutfitsProductsProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
